import axios from 'axios';
import _ from 'lodash';
import {useCallback, useEffect, useState} from 'react';

function loadAutocomplete(entityTypeId) {
    return axios.get(`/api/autocomplete/${entityTypeId}/config`).then((response) => response.data);
}

// this one is used for the data interface; it only retrieves information needed for performing the autocompletes
function useAutocomplete(entityTypeId) {
    const [configs, setConfigs] = useState(null);

    const reload = useCallback(() => loadAutocomplete(entityTypeId).then((opts) => setConfigs(opts)), []);

    useEffect(() => reload(), []);

    return {
        autocomplete: _.get(configs, 'autocomplete', null),
        reload,
    };
}

function performAutocomplete(entityTypeId, changedField, formData) {
    return axios
        .post(`/api/autocomplete/${entityTypeId}/complete`, {
            field: changedField,
            formData,
        })
        .then((response) => response.data);
}

export {performAutocomplete, useAutocomplete};
